// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { MfaProviderSchema } from '../inputTypeSchemas/MfaProviderSchema'

/////////////////////////////////////////
// MFA CONFIGURATION SCHEMA
/////////////////////////////////////////

export const MfaConfigurationSchema = z.object({
  providerType: MfaProviderSchema,
  id: z.string(),
  emailAddress: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  totpSecret: z.string().nullable(),
  totpAlgorithm: z.string().nullable(),
  totpDigits: z.number().int().nullable(),
  totpPeriod: z.number().int().nullable(),
  totpIssuer: z.string().nullable(),
  totpAccountName: z.string().nullable(),
  generatedAt: z.coerce.date().nullable(),
  isActive: z.boolean(),
  lastOtpCode: z.string().nullable(),
  lastOtpGeneratedAt: z.coerce.date().nullable(),
  providerMetadata: JsonValueSchema.nullable(),
})

export type MfaConfiguration = z.infer<typeof MfaConfigurationSchema>

export default MfaConfigurationSchema;
